import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SetSurveyId, SetSurveyUnderInspection } from '@shared/store/survey/survey.actions';
import { SurveysService } from './surveys.service';
import { SetCanAccessSurveySettings } from '@shared/store/canAccess/canAccess.actions';
import { Router } from '@angular/router';
import { UtilsService } from './utils.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class PerformSurveyService {
  constructor(
    private store: Store,
    private surveysService: SurveysService,
    private router: Router,
    private utils: UtilsService,
    private translate: TranslateService
  ) {}

  async performSurvey(surveyId: number) {
    try {
      this.utils.presentLoading();
      this.store.dispatch(new SetSurveyId(surveyId));
      const survey = await this.surveysService.getById(surveyId);
      this.store.dispatch(new SetSurveyUnderInspection(survey.data.survey));
      this.store.dispatch(new SetCanAccessSurveySettings(true));

      this.router.navigate(['realizar-vistoria', surveyId]);
    } catch (error) {
      console.error(error);
      if (error && error.error && error.error.message) {
        this.utils.showToast('', error.error.message);
      } else {
        this.utils.showToast('', `${this.translate.instant('PROVIDERS.WE_ARE_UNABLE')}`);
      }
    } finally {
      this.utils.dismissLoading();
    }
  }
}
